import { useEffect } from "react";

const upsertMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  const created = !element;
  const previousContent = element?.getAttribute("content");
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
  return { element, created, previousContent };
};

const restoreMeta = ({ element, created, previousContent }) => {
  if (created) {
    element.remove();
  } else if (previousContent === null) {
    element.removeAttribute("content");
  } else {
    element.setAttribute("content", previousContent);
  }
};

export function PortfolioMeta({ title, description, path }) {
  useEffect(() => {
    const previousTitle = document.title;
    const robots = upsertMeta("name", "robots", "noindex, nofollow, noarchive");
    const googlebot = upsertMeta("name", "googlebot", "noindex, nofollow, noarchive");
    const descriptionMeta = upsertMeta("name", "description", description);
    const ogTitle = upsertMeta("property", "og:title", title);
    const ogDescription = upsertMeta("property", "og:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    const canonicalWasCreated = !canonical;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }

    document.title = title;
    canonical.setAttribute("href", `https://metistechlabs.com${path}`);

    return () => {
      document.title = previousTitle;
      restoreMeta(robots);
      restoreMeta(googlebot);
      restoreMeta(descriptionMeta);
      restoreMeta(ogTitle);
      restoreMeta(ogDescription);
      if (canonicalWasCreated) canonical.remove();
    };
  }, [title, description, path]);

  return null;
}
